import React, { useContext, useState, useEffect } from 'react'
import { keyContext } from '../KeyContext';
import '../../components/css/popup.css';
import cross from '../../images/popup-cross.png'
// import { StartDateCalendar } from './StartDateCalendar';
// import StartClock from './StartClock';
import moment from 'moment'
import calendar from '../../images/Icon-Calendar.png'
// import close from '../images/close.png'
import da from "date-fns/locale/da";
import { DayPicker } from "react-day-picker";
import Modal from './Modal';
import { useNavigate } from "react-router-dom";

function InternetSellModal({ children, shown, close, data, activeColor, popupbg2, sec1color,sec2color,sec3color }) { 

  const key = sessionStorage.getItem("key");
  const {setWebEditing,setEditedEvId , setShowErrorModal, setErrorNo, setErrorText,setErrorStatus,setErrorType, setWaitingModal,setApiLoader,logOut,eventPushCheck} = useContext(keyContext)
  const [theStartDate, setTheStartDate]   = useState(data.WebbuyInfo?.startDate)
  const [theStartTime, setTheStartTime ] = useState(data.WebbuyInfo?.startTime)
  const [theEndDate,   setTheEndDate] = useState(data.WebbuyInfo?.endDate);
  const [theEndTime,   setTheEndTime] = useState(data.WebbuyInfo?.endTime);
  const [sec1selectedDate, setSec1selectedDate] = useState(new Date())
  const [sec2selectedDate, setSec2selectedDate] = useState(new Date())
  const [sec1Calendar, setsec1Calendar]         = useState(false);
  const [sec2Calendar, setsec2Calendar]         = useState(false);
  const [sec1Cal, setSec1Cal] = useState(false);
  const [sec2Cal, setSec2Cal] = useState(false);
  // const [sec3Cal, setSec3Cal] = useState(false);
  const [month, setMonth] = useState(); 
  let flag = false // flag determines overlap text when api takes more than 2 seconds to reply

const {setEventSaveObj} = useContext(keyContext)

const [active, setActive]  = useState(theStartDate === 0 && theStartTime === 0 ? true :false);
const [chosenTime1,setChosenTime1] = useState(false)
const [chosenTime2,setChosenTime2] = useState(false)
const [xdag1, setXdag1] = useState(false);
const [xdag2, setXdag2] = useState(false);
const [efterFors,setEFterFors] = useState(false)

const [xmin1, setXmin1] = useState(false)
const [xmin2, setXmin2] = useState(false)


const [sec1time, setsec1time] = useState('00:00');
const [sec2time, setsec2time] = useState('00:00');
const [sec1dagb4time,setsec1dagb4time] = useState('00:00')
const [sec2dagb4time,setsec2dagb4time] = useState('00:00')
const [sec1dagb4, setsec1dagb4] = useState('1');
const [sec2dagb4, setsec2dagb4] = useState('1');
const [sec1minb4, setsec1minb4] = useState('1');
const [sec2minb4, setsec2minb4] = useState('1');

const navigate = useNavigate();

// following 3 functions runs when starttime in valgt tidspunkt is changed in sec1,sec2,sec3
function handlesec1time () { //changes startTime
  setsec1time(document.getElementById('sec1tt').value)
  let time = document.getElementById('sec1tt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebbuyInfo.startTime = time_in_seconds
  
  fetchEventSave(data)   // sets startTime of webbuyInfo to the new start time in seconds 
  
}
// following 3 functions runs when time is changed in xdag3 in sec1, sec2, sec3
function handlesec1dagb4time(){
  setsec1dagb4time(document.getElementById('sec1dagtt').value)
  let time = document.getElementById('sec1dagtt').value    
    //  console.log(time, 'time')
    let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
    data.WebbuyInfo.startTime = time_in_seconds
  
    fetchEventSave(data)   // sets startTime of webbuyInfo to the new start time in seconds 
  }

  function handlesec2dagb4time(){
  setsec2dagb4time(document.getElementById('sec2dagtt').value)
  let time = document.getElementById('sec2dagtt').value    
    // console.log(time, 'time')
    let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
    data.WebbuyInfo.endTime = time_in_seconds
  
    fetchEventSave(data)   // sets endTime of webbuyInfo to the new end time in seconds 
  }

function handlesec2time () {  // changes endTime
  setsec2time(document.getElementById('sec2tt').value)
  let time = document.getElementById('sec2tt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebbuyInfo.endTime = time_in_seconds

  fetchEventSave(data)   // sets endTime of webbuyInfo to the new end time in seconds
     
}
// following 2 function runs when minutes before input is changed in sec1, sec2
function handlesec1minb4 () {
  setsec1minb4(document.getElementById('sec1mintt').value)
  // setTheStartTime(-document.getElementById('sec1mintt').value)
   const minChanged = -document.getElementById('sec1mintt').value
  
  
   // calling fetch event save and saving the new startTime in event save
   data.WebbuyInfo.startTime = minChanged
   data.WebbuyInfo.startDate = 0
   fetchEventSave(data)  // sets startTime of webbuyInfo to the new minute
  
  }
  // console.log(theStartTime, 'the start time')
  function handlesec2minb4 () {
    setsec2minb4(document.getElementById('sec2mintt').value)
    const minChanged = -document.getElementById('sec2mintt').value
  //  console.log(minChanged, 'min changed')
  
   // calling fetch event save and saving the new startTime in event save
   data.WebbuyInfo.endTime = minChanged
   data.WebbuyInfo.endDate = 0
   fetchEventSave(data)  // sets endTime of webreservInfo to the new minute
  }
// following 3 functions runs when day before input fields are changed in sec1,sec2.sec3
function handlesec1dagb4 (e) {
  // console.log(e.target.value)
  setsec1dagb4(e.target.value)
  
  setTheStartDate(-e.target.value)
   
   data.WebbuyInfo.startDate = -e.target.value
   fetchEventSave(data)  // sets start date of webbuyInfo to 0
  }

  function handlesec2dagb4 (e) {
    // console.log(e.target.value)
    setsec2dagb4(e.target.value)
    data.WebbuyInfo.endDate = -e.target.value
    fetchEventSave(data)  // sets end date of webbuyInfo to 0
    }

// following 3 functions runs when start date calendar is clicked in sec1, sec1, sec3
function handlesec1cal () {
  setsec1Calendar((current => !current))
}

function handlesec2cal () {
  setsec2Calendar((current => !current))
}

// dayclicked function runs when date is selected in calendar in sec1
function dayClickedSec1 () {
  setsec1Calendar(false)
  setSec1Cal(true)
} 

function dayClickedSec2 () {
  setsec2Calendar(false)
  setSec2Cal(true)
}


// call to event save when new date is selected from calendar on corresponding section
useEffect(() => {
  // console.log(sec1selectedDate, sec1Cal, 'inside use effect')
  if(sec1Cal === true ) {
    let dat = moment(sec1selectedDate, 'YYYY-MM-DD');
    let JulianDate = dat.diff(moment('2000-01-01', 'YYYY-MM-DD'), 'days') + 146097  
    data.WebbuyInfo.startDate = JulianDate
    fetchEventSave(data)  // sets startDate of webbuyInfo to the new selected date
  }
  if(sec2Cal === true) {
    // console.log(sec2selectedDate, sec2Cal, 'inside use effect')
   let dat = moment(sec2selectedDate, 'YYYY-MM-DD');
   let JulianDate = dat.diff(moment('2000-01-01', 'YYYY-MM-DD'), 'days') + 146097
  //  console.log(JulianDate) 
   data.WebbuyInfo.endDate = JulianDate
   fetchEventSave(data)  // sets endDate of webbuyInfo to the new selected date
  }
  
}, [sec1selectedDate,sec1Cal,sec2selectedDate,sec2Cal]);

// setting value from api to dom elements in radio buttons
useEffect(() => {
 // section 1
 if(theStartDate === 0 && theStartTime === 0) {
  setActive(true)
}
if(theStartDate > '155000'){
   setChosenTime1(true)
   setSec1selectedDate(moment('2000-01-01', 'YYYY-MM-DD').add(theStartDate  - 146097, 'days')._d)
   setsec1time(moment.utc(theStartTime*1000).format('HH:mm')) // formula for seconds to hh:mm
}
if(theStartDate < 0 ){
  setXdag1(true)
}
if(theStartTime < 0 && theStartDate === 0){
  setXmin1(true)
}
//section 2
if(theEndDate === 0 && theEndTime === 0){
  setEFterFors(true)
}
if(theEndDate > '155000') {
  setChosenTime2(true)
  setSec2selectedDate(moment('2000-01-01', 'YYYY-MM-DD').add(theEndDate  - 146097, 'days')._d)
   setsec2time(moment.utc(theEndTime*1000).format('HH:mm')) // formula for seconds to hh:mm
}
if(theEndDate < 0) {
  setXdag2(true)
}
if(theEndTime < 0 && theEndDate === 0) {
  setXmin2(true)
}

}, [theStartDate, theStartTime,theEndDate,theEndTime,]);
//---section 1 functions-----
function handleActive () {
  setActive(true)
  setChosenTime1(false)
  setXdag1(false)
  setXmin1(false)

  
 setTheStartDate(0)
 setTheStartTime(0)
 data.WebbuyInfo.startDate=0
 data.WebbuyInfo.startTime=0
 fetchEventSave(data)  // sets startTime and  startDate of webreserveIndo to 0
  }
  function handleChosenTime1() {
    setChosenTime1(true)
    setActive(false)
    setXdag1(false)
    setXmin1(false)
  }
  function handleXdag1 () {
    setXdag1(true)
    setActive(false)
    setChosenTime1(false)
    setXmin1(false)
  }
  function handleXmin1 () {
    setXmin1(true)
    setXdag1(false)
    setActive(false)
    setChosenTime1(false)
  }
//----section 2 functions----
function handleEfterFors () {
  setEFterFors(true)
  setChosenTime2(false)
  setXdag2(false)
  setXmin2 (false)

  data.WebbuyInfo.endDate = 0
  data.WebbuyInfo.endTime = 0
 fetchEventSave(data)  // sets endTime and  endDate of webreserveIndo to 0
}
function handleChosenTime2 () {
  setEFterFors(false)
  setChosenTime2(true)
  setXdag2(false)
  setXmin2 (false)
}
function handleXdag2 () {
  setEFterFors(false)
  setChosenTime2(false)
  setXdag2(true)
  setXmin2 (false)
}
function handleXmin2 () {
  setEFterFors(false)
  setChosenTime2(false)
  setXdag2(false)
  setXmin2 (true)
}

// event save api call
function fetchEventSave (event) {
  // console.log(event, 'the new event to be saved ')
    setWaitingModal(true)
 let taskTime = document.querySelector('#sec1dagtt');
 let taskTime2 = document.querySelector('#sec2tt');
 taskTime?.addEventListener('input', (e) => {
       taskTime.blur();
    })
    taskTime2?.addEventListener('input', (e) => {
       taskTime2.blur();
    })
     fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",
       
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',
        
       },
     
       body:`Key=${key}&eventdata=${JSON.stringify(event)}`
       
})
     .then(res =>  {
        flag =  true
   
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
          setWaitingModal(false)
           setApiLoader(false)
        if(result.Result === 1) {
             data= result
             setEventSaveObj(result)   
             setWebEditing(true)
             setEditedEvId(event.No)
             setSec1Cal(false)
             setSec2Cal(false)
        }
         else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {
            console.log('call event push check')
            eventPushCheck()
          }
        else {
          setShowErrorModal(true)
          setErrorNo(result.Result)
          setErrorText(result.ErrorDescription)
        }
})  
       setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
 }
 const windowHeight = window.innerHeight


return shown ? (
  <Modal open={shown}>

    <div>
          
          <div
              className="modalcontent" style={{width:'262px',borderRadius:'8px',position:'absolute',top:windowHeight> 1000 ? '50%' : '69px',left:windowHeight > 1000 ? '50%': '',transform: windowHeight > 1000 ? 'translate(-50%,-50%)':'',border:'1px solid white',padding:'1px',backgroundColor:'white'}}
              onClick={e => {
                // do not close modal if anything inside modal content is clicked
                e.stopPropagation();
              }}
            >
             
              {/* section 1 */}
              <section style={{marginBottom:'2px',borderBottomLeftRadius:'8px',borderBottomRightRadius:'8px',backgroundColor: sec1color,paddingBottom:'12px'}} >
                <div  style={{background: 'rgba(0, 0, 0, 0.08)',height:'45px',padding:'8px 20px'}}>
                <button onClick={close} style={{float:'right',marginRight:'-10px',marginTop:'-5px'}}>  
                   <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.24422 6.30408C7.16425 6.22317 7.11993 6.11623 7.11993 6.00249C7.11993 5.88781 7.16472 5.77994 7.24586 5.69879L9.35649 3.58792C9.364 3.58065 9.36916 3.57197 9.37596 3.56423L11.8053 1.13488C12.0649 0.875272 12.0649 0.454316 11.8053 0.194707C11.5457 -0.0649023 11.125 -0.0649023 10.8651 0.194707L8.4386 2.62124C8.42875 2.63015 8.41749 2.63672 8.40811 2.64634L6.29701 4.75674C6.14176 4.91176 5.89834 4.92137 5.72996 4.78981L1.13488 0.194707C0.875268 -0.0649023 0.454548 -0.0649023 0.194706 0.194707C-0.0649019 0.454316 -0.0649019 0.875272 0.194706 1.13488L2.60294 3.54312C2.6149 3.55719 2.62451 3.57244 2.63765 3.58557L4.74851 5.69668C4.82965 5.77759 4.87445 5.88547 4.87445 6.00015C4.87445 6.11459 4.82965 6.22247 4.74851 6.30361L2.63765 8.41449C2.62451 8.42762 2.6149 8.4431 2.60294 8.45693L0.194706 10.8652C-0.0649019 11.1248 -0.0649019 11.5457 0.194706 11.8054C0.324627 11.9353 0.49465 12 0.664908 12C0.834931 12 1.00519 11.9353 1.13488 11.8054L3.57219 9.36803C3.57688 9.36357 3.58227 9.36076 3.58673 9.3563L5.69783 7.24566C5.86551 7.07822 6.13778 7.07822 6.30546 7.24589L8.41656 9.35701L10.8651 11.8054C10.995 11.9353 11.1651 12 11.3353 12C11.5054 12 11.6756 11.9353 11.8053 11.8054C12.0649 11.5457 12.0649 11.1248 11.8053 10.8652L7.24422 6.30408Z" fill="#46484C"/>
</svg></button>
                  <p style={{margin:0,color:'#46484c',fontWeight:700,letterSpacing:'0.32px'}}>Internetsalg</p>  
</div>
<div style={{padding:'10px 12px',}} >
            <p style={{fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',paddingTop:'7px',height:'15px',color:activeColor}}>Salg på webside</p>

            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleActive}  style={{backgroundColor: active === true ? activeColor : ''}} type="radio" name="edit" id="" />  </label>
              <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>Aktiv </p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor=""    style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleChosenTime1} style={{backgroundColor: chosenTime1 === true ? activeColor : ''}}  type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>På et valgt tidspunkt</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}> 
              <input onClick={handleXdag1} style={{backgroundColor: xdag1 === true ? activeColor : ''}}   type="radio" name="edit" id="" /> </label>
              <p  style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px',}}>X dage før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXmin1} style={{backgroundColor: xmin1 === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X minutter før forestillingsstart</p>
            </div>
            </div>
             {/* ------under menus---- */}          
             {chosenTime1 === true || xdag1 === true || xmin1 === true ? <p className='fors_text' style={{paddingLeft:'12px'}}>Forestillingen er aktiv</p> : ''}
             { chosenTime1 === true ?
                  <div className='fors_container' style={{marginLeft:'12px'}}>
                   <div style={{backgroundColor:'#fff',width:'120px',height:'38px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'6px 5px'}}>
      <>
      
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',marginTop:'-4px'}}>Startdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{moment(sec1selectedDate).format('DD/MM/YY')}</p> 
           </div>
           <button style={{height:'29px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`}} onClick={handlesec1cal}><img src={calendar} alt="calendar" style={{marginLeft:'-2px',marginTop:'-5px'}}/></button> 

           {sec1Calendar? (
        <div style={{top:'50px'}}
          className={sec1Calendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
          <figure style={{ textAlign: "right" }}>
            <img src={cross}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handlesec1cal}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
              month={month} 
            onMonthChange={setMonth} 
            selected={sec1selectedDate}
            onSelect={setSec1selectedDate}
            onDayClick={dayClickedSec1}
           // disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        
        </>
        </div>
                    <svg style={{marginTop:'5px'}} xmlns="http://www.w3.org/2000/svg" width="1" height="32"     viewBox="0 0 1 30" fill="none">
                      <rect opacity="0.1" width="1" height="32" fill="#46484C"/>
                    </svg>
                    <div>
                       <div className='startTimeDiv1' style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px',paddingLeft:'10px'}}>Starttid:</p> 
                              <input type="time"    id='sec1tt' value={sec1time} onChange={handlesec1time} required=""/>
        
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
              { xdag1 === true ? 
              <div style={{marginLeft:'12px'}}>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" placeholder='1' value={sec1dagb4} onChange={(e) => handlesec1dagb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>dage før forestillingsstart</span>
                 </div>
                 <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'42px',display:'flex', justifyContent:'space-between',borderRadius:'5px',position:'relative' }}>
                         <div className='startTimeDiv2' style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Starttid:</p> 
                              <input type="time" id='sec1dagtt' value={sec1dagb4time} onChange={(e) => handlesec1dagb4time(e)} required=""/>
                            
                          </div> 
                      </div>
                    </div>
              </div>  : ''}
              { xmin1 === true ?
              <div style={{marginLeft:'12px'}}>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" id='sec1mintt'  value={sec1minb4} onChange={(e) => handlesec1minb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>minutter før forestillingsstart</span>
                 </div>
              </div>
                : ''              }
            </section>

                {/*-------------- section 2---------------------- */}
            <section style={{marginBottom:'2px',padding:'10px 12px',backgroundColor: sec2color,borderRadius:'8px'}}> 
            <p style={{fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',paddingTop:'7px',height:'15px',color:activeColor}}>Salg på webside afsluttes</p>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleEfterFors}  style={{backgroundColor: efterFors === true ? activeColor : ''}} type="radio" name="edit" id="" />  </label>
              <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>Efter forestillingsdato</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor=""    style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleChosenTime2} style={{backgroundColor: chosenTime2 === true ? activeColor : ''}}  type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>På et valgt tidspunkt</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}> 
              <input onClick={handleXdag2} style={{backgroundColor: xdag2 === true ? activeColor : ''}}   type="radio" name="edit" id="" /> </label>
              <p  style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px',}}>X dage før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXmin2} style={{backgroundColor: xmin2 === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X minutter før forestillingsstart</p>
            </div>
            {chosenTime2 === true || xdag2 === true || xmin2 === true ? <p className='fors_text'>Forestillingen afsluttes</p> : ''}
            
            { chosenTime2 === true ?
                  <div className='fors_container'>
                   <div style={{backgroundColor:'#fff',width:'120px',height:'38px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'6px 5px'}}>
      <>
      
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',marginTop:'-4px'}}>Slutdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{moment(sec2selectedDate).format('DD/MM/YY')}</p> 
           </div>
           <button style={{height:'29px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`}} onClick={handlesec2cal}><img src={calendar} alt="calendar" style={{marginLeft:'-2px',marginTop:'-5px'}}/></button> 

           {sec2Calendar? (
        <div style={{top:'50px'}}
          className={sec2Calendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
          <figure style={{ textAlign: "right" }}>
            <img src={cross}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handlesec2cal}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
              month={month} 
            onMonthChange={setMonth} 
            selected={sec2selectedDate}
            onSelect={setSec2selectedDate}
            onDayClick={dayClickedSec2}
         //   disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        
        </>
        </div>
                    <svg style={{marginTop:'5px'}} xmlns="http://www.w3.org/2000/svg" width="1" height="32"     viewBox="0 0 1 30" fill="none">
                      <rect opacity="0.1" width="1" height="32" fill="#46484C"/>
                    </svg>
                    <div>
                       <div className='startTimeDiv2' style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px',paddingLeft:'15px'}}>Sluttid:</p> 
                              <input type="time"  id='sec2tt' value={sec2time} onChange={handlesec2time} required=""/>
                            
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
              { xdag2 === true ? 
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" placeholder='1' value={sec2dagb4} onChange={(e) => handlesec2dagb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>dage før forestillingsstart</span>
                 </div>
                 <div>
                       <div className='startTimeDiv2' style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px',paddingLeft:'15px'}}>Sluttid:</p> 
                              <input type="time"   id='sec2dagtt' value={sec2dagb4time} onChange={(e) => handlesec2dagb4time(e)} required=""/>
                            
                          </div> 
                      </div>
                    </div>

              </div>  : ''}
              { xmin2 === true ?
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" id='sec2mintt' value={sec2minb4} onChange={(e) => handlesec2minb4(e)}   style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>minutter før forestillingsstart</span>
                 </div>
              </div>
                : ''              }
            </section>

          </div>
</div>
</Modal>
    ) : null
}

export default InternetSellModal